import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import DataTable from 'react-data-table-component'
import { IoTrashOutline } from 'react-icons/io5'
import { BsPencil } from 'react-icons/bs'
import axios from 'axios'
import { convertToIsraelTime } from '../../../util/formatsForDate'
import ModalNewBenefit from './ModalNewBenefit'
import ModalEdit from '../../ModalEdit'
import toast from 'react-hot-toast'

const CONTACT_TYPE_LABELS = {
  EMAIL: "אימייל",
  LINK: "קישור",
}

const Benefits = () => {
  const GET_URL = 'admin/qualification/benefits/all'
  const GET_DELETE = 'admin/qualification/benefits/delete'
  const URL_EXCLE = 'admin/qualification/benefits/report'
  const [modalIsOpen, setModalIsOpen] = useState("");
  const [id, setId] = useState("");
  const [fetchData, setFetchData] = useState([])
  const [loading, setloading] = useState(true)

  const getBenefits = async () => {
    await axios.get(GET_URL)
      .then(response => {
        setFetchData(response?.data || [])
      })
    setloading(false)
  }
  useEffect(() => {
    getBenefits()
  }, [])

  const columns = [
    {
      name: "פעולות",
      cell: row => <div className='flex'>
        <button title="מחיקה" className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
          setId(row)
          setModalIsOpen("Delete")
        }}><IoTrashOutline /></button>

        <button title="עריכה" className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
          setId(row)
          setModalIsOpen("Edit")
        }}><BsPencil /></button>
      </div>,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
      grow: 2,
    },
    {
      name: "מוצג",
      grow: 1,
      cell: (row) => row?.visible ? "כן" : "לא",
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "דמי חבר בלבד",
      grow: 2,
      cell: (row) => row?.requiresActiveDues ? "כן" : "לא",
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "סוג יצירת קשר",
      grow: 2,
      cell: (row) => CONTACT_TYPE_LABELS[row?.contactType] ?? (row?.contactType || ""),
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "תאריך סיום",
      grow: 2,
      cell: (row) => row?.endDate ? convertToIsraelTime(row?.endDate) : "",
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "תאריך התחלה",
      grow: 2,
      cell: (row) => row?.startDate ? convertToIsraelTime(row?.startDate) : "",
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "קישור ספק",
      grow: 3,
      cell: (row) => row?.providerUrl,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "אימייל ספק",
      grow: 3,
      cell: (row) => row?.providerEmail,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "שם ספק",
      grow: 2,
      cell: (row) => row?.providerName,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "תיאור",
      grow: 4,
      cell: (row) => row?.description,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
    {
      name: "שם הטבה",
      grow: 3,
      cell: (row) => row?.name,
      style: {
        fontSize: '10px',
        justifyContent: 'center',
      },
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: "1px solid black", // גבולות לטבלה כולה
      },
    },
    header: {
      style: {
        justifyContent: 'center',
      },
    },
    id: {
      style: {
        '&:2': { backgroundColor: '#EEEEEE' },
      }
    },
    headRow: {
      style: {
        justifyContent: 'center',
      },
    },
    headCells: {
      style: {
        '&:not(:last-of-type)': { borderRight: "1px solid black" }, // גבולות בין תאים
        justifyContent: 'center',
      },
    },
    cells: {
      style: {
        '&:not(:last-of-type)': { borderRight: "1px solid black", }// גבולות בין תאים
      }
    },
    rows: {
      style: {
        borderTop: "1px solid black", // גבולות בין שורות
        backgroundColor: '#FFFFFF',
        '&:active': {
          backgroundColor: '#EEEEEE',
        },
      },
    },
  }

  const downloadExcel = async () => {
    try {
      const response = await axios.get(URL_EXCLE, {
        responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'benefits_report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      toast.error("הורדת הדוח נכשלה");
    }
  }

  const handleDetele = async () => {
    await axios.delete(`${GET_DELETE}/${id.id}`).then(response => {
      if (response.status == 200) {
        toast.success("ההטבה נמחקה");
        getBenefits()
        handleColse()
      }
      else {
        console.log("error delete benefit")
      }
    })
  }
  const handleColse = () => {
    setModalIsOpen("")
  }

  return (
    <div className='w-full  p-3'>
      <HeaderTable active={"הטבות"} setModalIsOpen={setModalIsOpen}
        downloadExcel={downloadExcel}
        howmach={fetchData?.length} />
      <DataTable columns={columns} data={fetchData}
        customStyles={customStyles}
        paginationServer
        progressPending={loading} className='border' >
      </DataTable>
      {modalIsOpen == "New" && <ModalNewBenefit showModal={modalIsOpen == "New"} handleColse={handleColse}
        getDepartment={getBenefits}
      >
      </ModalNewBenefit>}
      {modalIsOpen == "Edit" && <ModalNewBenefit showModal={modalIsOpen == "Edit"} handleColse={handleColse}
        getDepartment={getBenefits}
        editData={id}
      >
      </ModalNewBenefit>}
      {modalIsOpen == "Delete" && <ModalEdit showModal={modalIsOpen == "Delete"} handleColse={handleColse} handleDetele={handleDetele}
        message="האם אתה בטוח שברצונך למחוק את ההטבה?"></ModalEdit>}
    </div>)
}

export default Benefits
